import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { connection_platform } from "../services/api";

let url_iframe = "";

const Ticket = () => {
  const user = useSelector((state) => state.informationusers);
  const ContactId = useSelector((state) => state.atendimento);
  const ServiceURL = useSelector((state) => state.serviceurl);
  const screen = useSelector((state) => state.infodisplay);

  if (ServiceURL.length !== 0) {
    let ArrayServiceURL = "";
    if (user.nameauth === "IngDesk") {
      ArrayServiceURL = ServiceURL.filter((url) => url.typeofcrm === "IngDesk");
      if (ArrayServiceURL.length !== 0) {
        url_iframe = ArrayServiceURL[0].param;
      }
    }
  }

  // url_iframe = "http://localhost:3000";
  return (
    <iframe
      frameBorder="0"
      src={`${url_iframe}/externo/${
        screen.ingdesk ? screen.ingdesk : "casos"
      }?login-master=ingenium&login-user=${
        user.username
      }&password-master=52e9f8a1500604b372a5c0908d93ee5f`}
      style={{ height: "100%", width: "100%" }}
      name="iframe_a"
      title="Iframe Example"
      allow="camera;microphone;clipboard-write"
    ></iframe>
  );
};

export default Ticket;
